import { render, staticRenderFns } from "./filter-version.vue?vue&type=template&id=14b86c4f&"
import script from "./filter-version.vue?vue&type=script&lang=ts&"
export * from "./filter-version.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports